import type { ChoreKind, ChoreSize } from "@/lib/schemas";

// Czy ten typ zadania to "XP only" — bez PLN, bez earn transaction, bez
// zmiany salda. Family (pomoc rodzinie) i sport (wyzwanie sportowe).
// Używaj zamiast `kind === "family"` gdy semantyka jest "to nie zarabia
// pieniędzy" (rozróżnij od specyficznego "to konkretnie pomoc rodzinie").
export function isXpOnlyKind(kind: ChoreKind): boolean {
  return kind === "family" || kind === "sport";
}

// Skalowanie XP przez size × kind. Sygnał: family/sport ceni się 2× extra
// (pomoc rodzinie i dbanie o ciało > zarobek), wyższy size = większy wysiłek/czas.
//
//   family/sport S=10  M=20  L=30
//   extra        S= 5  M=10  L=15
export function getXP(kind: ChoreKind, size: ChoreSize): number {
  const base = size === "S" ? 5 : size === "M" ? 10 : 15;
  return isXpOnlyKind(kind) ? base * 2 : base;
}
